export enum SupportedChatChannel {
  SMS = 'SMS',
  WHATSAPP = 'WB',
  VIBER = 'VB',
}
